function loadNavEditorials(url) {
  fetch(url)
    .then(function (response) {
      if (response.status !== 200 || !response.ok)
        throw new Error(`Unexpected response: status ${response.status}`);

      return response.json();
    })
    .then(function (aside) {
      let options = "";

      if (!aside.items)
        throw new Error("Unexpected editorials format: missing items");

      aside.items.forEach(editorial => {
        const urlEditoria = `/noticias/${editorial.slug}`;
        options += `<li><a href="${urlEditoria}">${editorial.name}</a></li>`;
      });

      $(".sub-menu-editorials").html(options);

      return aside;
    })
    .catch(function (error) {
      console.error(error);
    });
}
